import ConstantApi from '../../../../ConstantApi';
import axiosCall from '../../../axiosCall';
import axios from 'axios';
import { fetchPartyDetailsData } from '../../../partyDetails/partyDetails.action';
import { fetchCommonPropertyById } from '../../../property/common/commonProperty.actions';
import { fetchSeasonMaster } from '../../../seasonMaster/seasonMaster.actions';
import { fetchSizeInfoData } from '../../../sizeInfo/sizeInfo.actions';
import { fetchUnitMaster } from '../../../unitMaster/unitMaster.actions';
import { fetchYarnPOProgramDropdown, fetchYarnPOSalesOrderDropdown, fetchYarnPOSupplierDropdown } from '../../YarnPO/yarnPO/yarnPO.actions';
import { fetchCuttingDCDetailsById, fetchCuttingDCDetailsInnerGrid } from '../cuttingDcDetails/cuttingDcDetails.actions';
// import { FETCH_CUTTING_DC_REQUEST } from './cuttingDC.actionsType';

// hello
import {
    CREATE_CUTTING_DC_FAILURE,
    CREATE_CUTTING_DC_REQUEST,
    CREATE_CUTTING_DC_SUCCESS,
    CREATE_USER_FORM_CUTTING_DC,
    DELETE_CUTTING_DC_FAILURE,
    DELETE_CUTTING_DC_REQUEST,
    DELETE_CUTTING_DC_SUCCESS,
    FETCH_SINGLE_CUTTING_DC_FAILURE,
    FETCH_SINGLE_CUTTING_DC_REQUEST,
    FETCH_SINGLE_CUTTING_DC_SUCCESS,
    FETCH_CUTTING_DC_FAILURE,
    FETCH_CUTTING_DC_REQUEST,
    FETCH_CUTTING_DC_SUCCESS,
    CUTTING_DC_USERFORM_RESET,
    UPDATE_CUTTING_DC_FAILURE,
    UPDATE_CUTTING_DC_REQUEST,
    UPDATE_CUTTING_DC_SUCCESS,
    CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    FETCH_CUTTING_DC_INVOICE_REQUEST,
    FETCH_CUTTING_DC_INVOICE_SUCCESS,
    FETCH_CUTTING_DC_INVOICE_FAILURE,
    FETCH_CUTTING_DC_STYLE_REQUEST,
    FETCH_CUTTING_DC_STYLE_SUCCESS,
    FETCH_CUTTING_DC_STYLE_FAILURE,
    FETCH_CUTTING_DC_FORMAT_REQUEST,
    FETCH_CUTTING_DC_FORMAT_SUCCESS,
    FETCH_CUTTING_DC_FORMAT_FAILURE,
    FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_REQUEST,
    FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_SUCCESS,
    FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_FAILURE,
    CLOSE_BTN_POST_FAILURE_CUTTING,
    CLOSE_BTN_POST_SUCCESS_CUTTING,
    CLOSE_BTN_POST_REQUEST_CUTTING,
    DELETE_CUTTING_DC_REQUEST_CALL_OFF,
    DELETE_CUTTING_DC_SUCCESS_CALL_OFF,
    DELETE_CUTTING_DC_FAILURE_CALL_OFF,
    CUTTING_DC_REQUEST_RETURN_QTY,
    DELETE_CUTTING_DC_SUCCESS_RETURN_QTY,
    DELETE_CUTTING_DC_FAILURE_RETURN_QTY
} from './cuttingDC.actionsType';


// FETCH PROPERTY MASTER
export let fetchCuttingDC = (startDate, endDate, unitId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.cuttingDCMasterGET}?fromDate=${startDate}&toDate=${endDate}&FldFKUnitId=${-1}`,
        responseTypeRequest: FETCH_CUTTING_DC_REQUEST,
        responseTypeSuccess: FETCH_CUTTING_DC_SUCCESS,
        responseTypeFailure: FETCH_CUTTING_DC_FAILURE
    };
    return axiosCall(config);
};

// create user Form
export let createCuttingDCUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_CUTTING_DC, payload: { key, value } });
    };
};

// CREATE PROPERTY MASTER
export let createCuttingDCMaster = (formData, modalClose, startDate, endDate, isDetail, unitId) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        fldSupplierPANNo: 'static',
        fldSupplierPhoneNo: 'static',
        flDeliveryAtPANNo: 'static',
        fldDeliveryPhoneNo: 'static',
        ...formData,
        fldFKSupplierID: parseInt(formData.fldFKSupplierID),
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKDepartment: parseInt(formData.fldFKDepartment),
        // fldFKFormatMaster: parseInt(formData.fldFKFormatMaster),
        fldFKStyle: parseInt(formData.fldFKStyle),
        fldFKSizeInfo: 0,
        fldDCNo: 'Auto Generated',
        fldDCDate: today.toISOString(),
        fldDeliveryStartDate: formData?.fldDeliveryStartDate ? formData.fldDeliveryStartDate : today.toISOString(),
        fldDeliveryEndDate: formData?.fldDeliveryEndDate ? formData.fldDeliveryEndDate : today.toISOString(),
        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        // fldFKDeliveryAt: formData.fldIsInHouseDelivery ? parseInt(formData.fldFKUnitId) : parseInt(formData.fldFKDeliveryAt),

        fldFKDeliveryAt: parseInt(formData.fldFKDeliveryAt),

        fldNoofBags: formData.fldNoofBags ? Number(formData.fldNoofBags) : 0,
        fldTotalQty: formData.fldTotalQty ? Number(formData.fldTotalQty) : 0,
        fldInwardQty: 0,
        fldCancelQty: 0,
        fldBalanceQty: 0,
        fldPreparedBy: '',
        fldPrepareDate: today.toISOString(),
        fldVerifyBy: '',
        fldVerifyDate: today.toISOString(),
        fldAuthorizeBy: '',
        fldAuthorizeDate: today.toISOString(),
        fldInwardBy: '',
        fldInwardDate: today.toISOString(),
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString(),
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldIsInHouseProduction: formData?.fldIsInHouseProduction,
        fldApprovalStatus: 0,
        fldUnitCode: '',
        fldUnitName: '',
        fldUnitAddress1: '',
        fldUnitAddress2: '',
        fldUnitFKArea: 0,
        fldUnitCountry: '',
        fldUnitState: '',
        fldUnitCity: '',
        fldUnitArea: '',
        fldUnitPincode: '',
        fldUnitGSTNo: '',
        fldSupplierCode: '',
        fldSupplierName: '',
        fldSupplierAddress1: '',
        fldSupplierAddress2: '',
        fldSupplierFKArea: 0,
        fldSupplierCountry: '',
        fldSupplierState: '',
        fldSupplierCity: '',
        fldSupplierArea: '',
        fldSupplierPincode: '',
        fldSupplierGSTNo: '',
        fldDeliveryAtCode: '',
        fldDeliveryAtName: '',
        fldDeliveryAtAddress1: '',
        fldDeliveryAtAddress2: '',
        fldDeliveryAtFKArea: 0,
        fldDeliveryAtCountry: '',
        fldDeliveryAtState: '',
        fldDeliveryAtCity: '',
        fldDeliveryAtArea: '',
        fldDeliveryAtPincode: '',
        fldDeliveryAtGSTNo: '',
        fldItemsGrossValue: formData.fldItemsGrossValue ? Number(formData.fldItemsGrossValue) : 0,
        fldItemsTaxableValue: formData.fldItemsTaxableValue ? Number(formData.fldItemsTaxableValue) : 0,
        fldItemsGSTValue: formData.fldItemsGSTValue ? Number(formData.fldItemsGSTValue) : 0,
        fldItemsTotalValue: formData.fldItemsTotalValue ? Number(formData.fldItemsTotalValue) : 0,
        fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        fldGrandGrossValue: formData.fldGrandGrossValue ? Number(formData.fldGrandGrossValue) : 0,
        fldOtherPlusValue: formData.fldOtherPlusValue ? Number(formData.fldOtherPlusValue) : 0,
        fldOtherMinusValue: formData.fldOtherMinusValue ? Number(formData.fldOtherMinusValue) : 0,
        fldRoundoff: formData.fldRoundoff ? Number(formData.fldRoundoff) : 0,
        fldGrandTotalValue: formData.fldGrandTotalValue ? Number(formData.fldGrandTotalValue) : 0,
        fldItemsSGSTValue: 0,
        fldItemsCGSTValue: 0,
        fldItemsIGSTValue: 0,
        fldFKPaymentTerms: parseInt(formData.fldFKPaymentTerms),
        fldDeliveryName: ''

    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.cuttingDCMasterPOST}`,
        responseTypeRequest: CREATE_CUTTING_DC_REQUEST,
        responseTypeSuccess: CREATE_CUTTING_DC_SUCCESS,
        responseTypeFailure: CREATE_CUTTING_DC_FAILURE,
        resetFormData: isDetail ? CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB : CUTTING_DC_USERFORM_RESET,
        modalClose,
        PoDcInwardNo: 'fldPONO',
        PoDcInwardType: 'DC',
        isPopupOpen: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchCuttingDC(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let getSingleCuttingDCMaster = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.cuttingDCMasterGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_CUTTING_DC_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_CUTTING_DC_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_CUTTING_DC_FAILURE,
        singlApiArray: [
            fetchSeasonMaster(),
            fetchYarnPOSupplierDropdown('TblCuttingDC'),
            fetchYarnPOProgramDropdown('TblCuttingDC'),
            fetchCommonPropertyById(52),
            fetchCommonPropertyById(46),
            fetchCommonPropertyById(28),
            fetchUnitMaster(),
            fetchSizeInfoData(),
            fetchCuttingDCFormatGetList()
        ]
    };
    return axiosCall(config);
};

export let getCuttingDCInvoiceDataV2 = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.cuttingDCInvoiceGET}/${id}`,
        responseTypeRequest: FETCH_CUTTING_DC_INVOICE_REQUEST,
        responseTypeSuccess: FETCH_CUTTING_DC_INVOICE_SUCCESS,
        responseTypeFailure: FETCH_CUTTING_DC_INVOICE_FAILURE
    };
    return axiosCall(config);
    // return (dispatch) => {
    //     dispatch({ type: FETCH_CUTTING_DC_INVOICE_REQUEST });
    //     var config = {
    //         method: 'get',
    //         url: `${Config.baseUrl}${ConstantApi.cuttingDCInvoiceGET}/${id}`,
    //         headers: {
    //             // 'Access-Control-Allow-Origin': true,
    //             'Content-Type': 'application/json',
    //             Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
    //             dbname: Cookies.get('DATABASE')
    //         }
    //     };
    //     axios(config)
    //         .then((response) => {
    //             dispatch({ type: FETCH_CUTTING_DC_INVOICE_SUCCESS, updatePayload: response.data });

    //             dispatch(fetchCuttingDCDetailsById(response?.data[0]?.FldFkDCNO));
    //         })
    //         .catch((error) => {
    //             dispatch({ type: FETCH_CUTTING_DC_INVOICE_FAILURE, updatePayload: error });
    //         });
    // };
};

//UPDATE PROPERTY MASTER
export let updateCuttingDCMaster = (formData, id, startDate, endDate, empty, unitId) => {
    let today = new Date();
    let data = JSON.stringify({
        ...formData,
        fldId: parseInt(id),
        fldFKSupplierID: parseInt(formData.fldFKSupplierID),
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKDepartment: parseInt(formData.fldFKDepartment),
        fldFKFormatMaster: parseInt(formData.fldFKFormatMaster),
        // fldFKStyle: parseInt(formData.fldFKStyle),
        fldFKSizeInfo: parseInt(formData.fldFKSizeInfo),
        fldDCNo: formData?.fldDCNo,
        fldDCDate: formData?.fldDCDate,
        fldDeliveryStartDate: formData.fldDeliveryStartDate,
        fldDeliveryEndDate: formData.fldDeliveryEndDate,
        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        // fldFKDeliveryAt: formData.fldIsInHouseDelivery ? 0 : parseInt(formData.fldFKDeliveryAt),
        fldFKDeliveryAt: parseInt(formData.fldFKDeliveryAt),
        fldNoofBags: formData.fldNoofBags ? Number(formData.fldNoofBags) : 0,
        fldTotalQty: formData.fldTotalQty ? Number(formData.fldTotalQty) : 0,
        fldInwardQty: formData?.fldInwardQty,
        fldCancelQty: formData?.fldCancelQty,
        fldBalanceQty: formData?.fldBalanceQty,
        fldIsInHouseProduction: formData?.fldIsInHouseProduction,
        // fldVerifyBy: '',
        // fldVerifyDate: today.toISOString(),
        // fldAuthorizeBy: '',
        // fldAuthorizeDate: today.toISOString(),
        // fldInwardBy: '',
        fldInwardDate: today.toISOString(),
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString(),
        fldFKStatus: formData.fldFKStatus,
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldPreparedBy: formData.fldPreparedBy,
        fldPrepareDate: formData.fldPrepareDate,
        fldVerifyBy: formData.fldVerifyBy,
        fldVerifyDate: formData.fldVerifyDate,
        fldAuthorizeBy: formData.fldAuthorizeBy,
        fldAuthorizeDate: formData.fldAuthorizeDate,
        fldItemsGrossValue: formData.fldItemsGrossValue ? Number(formData.fldItemsGrossValue) : 0,
        fldItemsTaxableValue: formData.fldItemsTaxableValue ? Number(formData.fldItemsTaxableValue) : 0,
        fldItemsGSTValue: formData.fldItemsGSTValue ? Number(formData.fldItemsGSTValue) : 0,
        fldItemsTotalValue: formData.fldItemsTotalValue ? Number(formData.fldItemsTotalValue) : 0,
        fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        fldGrandGrossValue: formData.fldGrandGrossValue ? Number(formData.fldGrandGrossValue) : 0,
        fldOtherPlusValue: formData.fldOtherPlusValue ? Number(formData.fldOtherPlusValue) : 0,
        fldOtherMinusValue: formData.fldOtherMinusValue ? Number(formData.fldOtherMinusValue) : 0,
        fldRoundoff: formData.fldRoundoff ? Number(formData.fldRoundoff) : 0,
        fldGrandTotalValue: formData.fldGrandTotalValue ? Number(formData.fldGrandTotalValue) : 0,
        fldFKPaymentTerms: parseInt(formData.fldFKPaymentTerms),
    });
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.cuttingDCMasterPATCH}/${id}`,
        responseTypeRequest: UPDATE_CUTTING_DC_REQUEST,
        responseTypeSuccess: UPDATE_CUTTING_DC_SUCCESS,
        responseTypeFailure: UPDATE_CUTTING_DC_FAILURE,
        resetFormData: CUTTING_DC_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchCuttingDC(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER
export let deleteCuttingDCMaster = (id, startDate, endDate, unitId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.cuttingDCMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_CUTTING_DC_REQUEST,
        responseTypeSuccess: DELETE_CUTTING_DC_SUCCESS,
        responseTypeFailure: DELETE_CUTTING_DC_FAILURE,
        modalClose: true,
        getAllData: fetchCuttingDC(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

export let fetchCuttingDCStyleGetList = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.cuttingDCStyleMasterGET}?ActionCode=DYD`,
        responseTypeRequest: FETCH_CUTTING_DC_STYLE_REQUEST,
        responseTypeSuccess: FETCH_CUTTING_DC_STYLE_SUCCESS,
        responseTypeFailure: FETCH_CUTTING_DC_STYLE_FAILURE
    };
    return axiosCall(config);
};

export let fetchCuttingDCFormatGetList = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.cuttingDCFormatMasterGET}`,
        responseTypeRequest: FETCH_CUTTING_DC_FORMAT_REQUEST,
        responseTypeSuccess: FETCH_CUTTING_DC_FORMAT_SUCCESS,
        responseTypeFailure: FETCH_CUTTING_DC_FORMAT_FAILURE
    };
    return axiosCall(config);
};


export let fetchCutQtyWithSizeForPrint = (dc) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.cutDCQtyWithSizeForPrintGET}?FldFKDCNO=${dc}`,
        responseTypeRequest: FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_REQUEST,
        responseTypeSuccess: FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_SUCCESS,
        responseTypeFailure: FETCH_CUTTING_DC_QTY_WITH_SIZE_FOR_PRINT_FAILURE
    };
    return axiosCall(config);
};


export let PostCloseIconApiCutting = (id, reason) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.postCloseIconCUT}?FldId=${id}&FldReason=${reason?.reason}&IsRollBack=${reason?.checkbox}`,
        responseTypeRequest: CLOSE_BTN_POST_REQUEST_CUTTING,
        responseTypeSuccess: CLOSE_BTN_POST_SUCCESS_CUTTING,
        responseTypeFailure: CLOSE_BTN_POST_FAILURE_CUTTING,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config, true);
};



export let cuttingInwardReturnQty = (data, id) => {
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.postReturnQty}`,
        responseTypeRequest: CUTTING_DC_REQUEST_RETURN_QTY,
        responseTypeSuccess: DELETE_CUTTING_DC_SUCCESS_RETURN_QTY,
        responseTypeFailure: DELETE_CUTTING_DC_FAILURE_RETURN_QTY,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: getCuttingDCInvoiceDataV2(id)



        // dispatch(getCuttingDCInvoiceDataV2(e.row.data.fldFKDcNo));
    };
    return axiosCall(config);
};



export let deleteCuttingDCCallOff = (id) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.deleteDCDetailsCallOff}/${id}`,
        responseTypeRequest: DELETE_CUTTING_DC_REQUEST_CALL_OFF,
        responseTypeSuccess: DELETE_CUTTING_DC_SUCCESS_CALL_OFF,
        responseTypeFailure: DELETE_CUTTING_DC_FAILURE_CALL_OFF,
        getAllData: fetchCuttingDCDetailsById(id)
    };
    return axiosCall(config);
};
